.heading {
  composes: heading from '../utils.module.css';
}

.inputWrapper {
  display: flex;
  margin-bottom: 0.5rem;
}

.input {
  composes: input from '../utils.module.css';
  flex: 1 1 0%;
  max-width: 30em;
}

.openBtn {
  composes: primaryBtn from '../utils.module.css';
  margin-left: 0.5rem;
  white-space: nowrap;
}

.hint {
  composes: hint from '../utils.module.css';
  max-width: 40em;
  margin-top: 0.375rem;
}

.hintIcon {
  margin-right: 0.5em;
  margin-bottom: -2px;
}
